import { useState, useEffect } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export function CompanyGuard({ children }) {
  const router = useRouter();
  const { user, loading } = useAuthContext();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (loading) return;

    if (!user?.CompanyId) {
      router.replace(paths.companies.root);
      return;
    }

    setIsChecking(false);
  }, [user, loading, router]);

  if (isChecking) return <SplashScreen />;

  return <>{children}</>;
}
